const windowStatePlugin = {
  install: function install(Vue: any, options: { [key: string]: number }) {
    // ウィンドウの状態
    const state = {
      width: 0,
      height: 0,
    };

    Vue.util.defineReactive(Vue.prototype, '$mq', '');
    Vue.util.defineReactive(Vue.prototype, '$window', state);

    const sortedOptions = new Map<string, number>();
    let infinityMq = '';
    Object.keys(options).sort((a, b) => {
      if (options[a] < options[b]) { return -1; }
      if (options[a] > options[b]) { return 1; }
      return 0;
    }).forEach((key) => {
      const value = options[key];
      if (value === Infinity) {
        if (infinityMq === '') {
          infinityMq = key;
        }
      } else {
        sortedOptions.set(key, value);
      }
    });

    // ウィンドウのサイズを取得
    const onResize = () => {
      const width = document.documentElement.clientWidth;
      state.width = width;
      state.height = document.documentElement.clientHeight;

      let mq = infinityMq;
      for (const [key, value] of sortedOptions) {
        if (width < value) {
          mq = key;
          break;
        }
      }
      Vue.set(Vue.prototype, '$mq', mq);
    };

    window.addEventListener('resize', onResize);
    onResize();
  }
};
export default windowStatePlugin;
